export enum EmploymentKind {
Permanent,
FixedTerm,
ByProject,
SubContract,
Internship,
Trainee,
IDAX,
IDOX,
Installed,
}
